import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreFooter',
  props: {
    footerData: {
      type: Object,
      required: true
    },
    publicDashboardVersion: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      responsive: false,
      responsiveInput: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['language'])), {}, {
    version: function version() {
      return this.$store.state.app.packageVersion;
    },
    imprintUrl: function imprintUrl() {
      var lang = this.language || 'de';
      return get(this.footerData, "".concat(lang, ".imprintUrl"));
    },
    aboutUsUrl: function aboutUsUrl() {
      var lang = this.language || 'de';
      return get(this.footerData, "".concat(lang, ".aboutUsUrl"));
    },
    copyrightUrl: function copyrightUrl() {
      var lang = this.language || 'de';
      return get(this.footerData, "".concat(lang, ".copyrightUrl"));
    },
    copyrightText: function copyrightText() {
      var lang = this.language || 'de';
      return get(this.footerData, "".concat(lang, ".copyrightText"));
    }
  }),
  mounted: function mounted() {
    this.onResponsiveInverted();
    window.addEventListener('resize', this.onResponsiveInverted);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted);
  },
  methods: {
    onResponsiveInverted: function onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    }
  }
};